
(function($) {
	var Application = Backbone.View.extend({
		el: 'body',

		Views: [],
		Events: {},

		initialize: function(options) {
			_.extend(this.Events, Backbone.Events);
		}
	});

	window.App = window.App || new Application();

	$(function() {
		App.Events.trigger('ready');

		// Instantiate any extensions necessary
		$('.responsive').not('#hero .section-background .responsive').bgResponsiveImage();
	});
})(jQuery); 